var _path, _path2, _path3, _path4, _circle, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle2, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: "100px",
    height: "100px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#52bea0",
    d: "M39,88.649L39,88.649c-7.18,0-13-5.82-13-13l0,0c0-7.18,5.82-13,13-13h13v13 C52,82.829,46.18,88.649,39,88.649z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f599a0",
    d: "M65.5,37.649H52v-25h13.5c6.904,0,12.5,5.596,12.5,12.5l0,0C78,32.052,72.404,37.649,65.5,37.649z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e85654",
    d: "M38.5,12.649H52v25H38.5c-6.904,0-12.5-5.596-12.5-12.5l0,0C26,18.245,31.596,12.649,38.5,12.649z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#787ab5",
    d: "M38.5,37.649H52v25H38.5c-6.904,0-12.5-5.596-12.5-12.5l0,0C26,43.245,31.596,37.649,38.5,37.649z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 51.149,
    r: 11.5,
    fill: "#39c1d7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1f212b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M39,88.649L39,88.649c-7.18,0-13-5.82-13-13l0,0c0-7.18,5.82-13,13-13h13v13C52,82.829,46.18,88.649,39,88.649z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1f212b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M42.5,83.397 c-1.067,0.483-2.252,0.752-3.5,0.752l0,0c-4.694,0-8.5-3.806-8.5-8.5l0,0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1f212b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M46.212,80.149 c-0.34,0.544-0.741,1.047-1.192,1.5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1f212b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M47.5,72.149v3.5 c0,0.512-0.045,1.013-0.132,1.5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1f212b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M47.5,67.149v2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1f212b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M65.5,37.649H52v-25h13.5c6.904,0,12.5,5.596,12.5,12.5l0,0C78,32.052,72.404,37.649,65.5,37.649z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1f212b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M65.5,17.149 c4.418,0,8,3.582,8,8l0,0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1f212b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M56.86,17.149h5.64"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1f212b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M38.5,12.649H52v25H38.5c-6.904,0-12.5-5.596-12.5-12.5l0,0C26,18.245,31.596,12.649,38.5,12.649z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1f212b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M38.5,37.649H52v25H38.5c-6.904,0-12.5-5.596-12.5-12.5l0,0C26,43.245,31.596,37.649,38.5,37.649z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 51.149,
    r: 11.5,
    fill: "none",
    stroke: "#1f212b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1f212b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M60.138,46.649 c1.284-1.528,3.21-2.5,5.362-2.5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1f212b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M59.174,54.149 c-0.432-0.909-0.674-1.926-0.674-3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1f212b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M70.862,55.649 c-1.284,1.528-3.21,2.5-5.362,2.5c-1.074,0-2.091-0.242-3-0.674"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1f212b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M72.5,51.149 c0,0.695-0.101,1.366-0.29,2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.da67ac1124310fb0837f42100a7bf372.svg";
export { ForwardRef as ReactComponent };